import { countries } from 'country-data-list';
import React from 'react';

import { ListGroup, ListGroupItem } from '@/components/ui/list-group';
import { User } from '@/types';
import { convertUnixTimestamp } from '@/utils/unix';

interface UserInfoListProps {
  userData: User;
}

const UserInfoList: React.FC<UserInfoListProps> = ({ userData }) => {
  return (
    <ListGroup>
      <ListGroupItem>
        {
          countries.all.find((country) => country.alpha2 == userData.country)
            ?.name
        }
      </ListGroupItem>
      <ListGroupItem>
        Joined {convertUnixTimestamp(userData.regTimestamp).newFormat}
      </ListGroupItem>
      <ListGroupItem>{userData.views} Profile views</ListGroupItem>
    </ListGroup>
  );
};

export default UserInfoList;
